export const commonConfig = {
  darkTheme: true,
  classicHeader: true,
};

export const typeWriiterStrings = {
  en: [
    'Our Team is specialized in: ',
    'Bunisess Analysis. ',
    'Graphic design. ',
    'App development. ',
    'Cloud Migration and Development. ',
    'App and System Security. ',
  ],
  fr: [
    'Notre équipe est spécialisée dans : ',
    "L'Analyse d'affaire. ",
    "La conception d'interfaces utilisateurs interactives ",
    'La conception de solutions web et mobile ',
    "La migration de votre infrastruictures et solutions sur l'infonuagique ",
    'La securité de vos systèmes ',
  ],
};

export const services = [
  {
    nameKey: 'services-uiux',
    descKey: 'services-uiux-desc',
    icon: 'fas fa-pencil-ruler',
  },
  {
    nameKey: 'services-apps',
    descKey: 'services-apps-desc',
    icon: 'fas fa-code',
  },
  {
    nameKey: 'services-bi',
    descKey: 'services-bi-desc',
    icon: 'fas fa-chart-area',
  },
  {
    nameKey: 'services-seo',
    descKey: 'services-seo-desc',
    icon: 'fas fa-bullhorn',
  },
  {
    nameKey: 'services-cloud',
    descKey: 'services-cloud-desc',
    icon: 'fas fa-cloud',
  },
  {
    nameKey: 'services-sec',
    descKey: 'services-sec-desc',
    icon: 'fas fa-lock',
  },
];

export const images = [
  {
    url: 'images/slides/bi.jpg',
    captionKey: 'slide-caption.bi',
    defaultCaption: 'Business Analysis',
  },
  {
    url: 'images/slides/develop.jpg',
    captionKey: 'slide-caption.dev',
    defaultCaption: 'Web and Mobile App development',
  },
  {
    url: 'images/slides/cloud.jpg',
    captionKey: 'slide-caption.cloud',
    defaultCaption: 'Cloud Migration and Development',
  },
  {
    url: 'images/slides/ui-ux.jpg',
    captionKey: 'slide-caption.uiux',
    defaultCaption: 'User Interface design',
  },
  {
    url: 'images/slides/devsec.jpg',
    captionKey: 'slide-caption.sec',
    defaultCaption: 'System and Software Security',
  },
];

export const teamDetails = {
  en: [
    {
      picture: 'images/team/Herve.jpeg',
      name: 'Louis-Herve Dibi',
      desc: `Louis-Herve Dibi is an experienced IT professional. He has proven expertise in digital transformation and creating business value for organizations by capitalizing on the benefits offered by technologies.
      He has extensive experience with projects in the banking sector. He has contributed to the digital transformation of significant organizations such as the National Bank of Canada.
      He holds a Master's degree in Information Technology Management (M.Sc), and degree in Artificial Intelligence for organizations, both from Laval University`,
    },
    {
      picture: 'images/team/Brahima.jpeg',
      name: 'Brahima Traore',
      desc: `Brahima Traoré is an expert in web and mobile software development, with years of experience serving numerous companies in the financial sector. He contributed to the digital transformation of some well known companies, such as the National Bank of Canada, as well as many other companies in health and retail business. He is currently working with some   companies for building robust and secure applications, guiding them in a gradual migration to the cloud. Brahima Traoré is graduated from Laval University and is also certified as a developer on Amazon's cloud (AWS) and Microsoft's (Azure) cloud platforms`,
    },
    {
      picture: 'images/team/Alban.png',
      name: 'Alban Georges Babadjidé',
      desc: `Alban is an expert in web development with a focus on user experience, having completed numerous projects 
      in Canada and abroad. I has proven expertise, mostly in content management systems (CMS) development and Search engine optimization (SEO).
      His passion for search engine optimization has driven him to create customized strategies that propelled many websites to the top of rankings, by incorporating modern technologies mandated by next-generation browsers. Alban is graduated in Telecommunication and Web Development.`,
    },
    {
      picture: 'images/team/ElHacen.jpeg',
      name: 'EL HACEN DIA',
      desc: `El Hacen is a seasoned professional in the field of information technology, with over 8 years of expertise in web and mobile solution development. He has proven expertise in consulting for Azure cloud integration projects and complex software implementation as well as large-scale project management.
      His experience is built while working for organizations such as Desjardins Bank and Korem and has contributed to the implementation, the integration and deployment tools on Azure.
      He holds a Master's degree in Computer Science from Laval University and is certified as a "Certified Kubernetes Administrator" (CKA) and "Microsoft Certified DevOps Engineer Expert`,
    },
    {
      picture: 'images/team/kabore.jpeg',
      name: 'Windwaogo Christian Kabore',
      desc: `Windwaogo Christian is a professional in the field of IT governance, audit, and security (ITGAS). He has many years of experience in technological infrastructure, application security, and access and  identity management. He has been involved in the digital transformation of large organizations such as SNC-LAVALIN, Revenu Québec, the Société de l’assurance automobile du Québec (SAAQ), and the Commission des normes, de l'équité, de la santé et de la sécurité du travail (CNESS).
      He holds a Master's degree in Applied Computer Science for Business Management (MAIGE) from the Institut Burkinabè des Arts et Métiers (IBAM) and a Graduate Diploma in IT governance, audit, and security from the University of Sherbrooke`,
    },
  ],
  fr: [
    {
      picture: 'images/team/Herve.jpeg',
      name: 'Louis-Herve Dibi',
      desc: `Louis-Herve Dibi est un professionnel expérimenté dans le domaine des Technologies de l’Information.
      Il possède une expertise éprouvée dans la transformation numérique et la création de valeurs d’affaires pour les organisations en capitalisant sur les bénéfices qu’offrent les technologies. Il possède une très bonne expérience avec les projets dans le secteur bancaire. Il a contribué à la transformation numérique d’organisations d’envergures comme la Banque Nationale du Canada.
      Il détient une Maitrise en gestion des Technologies de l’Information (M. Sc) de l’Université Laval, puis une formation en Intelligence Artificielle pour les organisations de la même université.`,
    },
    {
      picture: 'images/team/Brahima.jpeg',
      name: 'Brahima Traoré',
      desc: `Brahima Traoré est un expert en développement de solutions logiciels Web et Mobiles, 
      avec des années d’experience au services de nombreuses entreprises dans le secteur financier. Son experience a contribuée à la transformation digitale de  certaines entreprises comme la Banque National du Canada et de beaucoup d’autres entreprises oeuvrant dans le domaine de la santé et le commerce de détails. Il offre présentement ses services aux entreprises pour le developpement de solutions applicatives robustes et securisés et leur aide à migrer progressivement vers l’infonuagique.
      Brahima Traoré est diplomé de l’Université Laval et est egalement certifié développeur sur le cloud de Amazon (AWS) et de Microsoft  (Azure)`,
    },
    {
      picture: 'images/team/Alban.png',
      name: 'Alban Georges Babadjidé',
      desc: `Alban est un expert en développement web axé sur l’experience utilisateur ayant realisé de nombreux projects au Canada et à l’international.
      Il dispose d’une expertise eprouvée surtout dans le developpement des systemes de gestion de contenue (CMS), référencement des sites web (SEO).
      Sa passion pour l'optimisation des moteurs de recherche l’a poussé à créer des stratégies sur mesure qui propulsent les sites web vers les sommets des classements, cela en integrant les technologies modernes imposées par les navigateurs de nouvelle generation. Alban est diplomé en Télécomunication et Développement Web.`,
    },
    {
      picture: 'images/team/ElHacen.jpeg',
      name: 'EL HACEN DIA',
      desc: `El Hacen est un professionnel chevronné dans le domaine des technologies de l'information, avec une expertise de 8 ans en développement de solutions Web et mobile. Il excelle dans le conseil, que ce soit pour des projets d'intégration infonuagique Azure, de programmation complexe, ou de gestion de projets d'envergure.
      Il a occupé des postes clés chez des organisations renommées telles que la Banque Desjardins et Korem et a contribué dans la mise en place des outils d'intégration et de déploiement sur Azure.
      Il possède une maitrise en Informatique de l'Université Laval et est certifié "Certified Kubernetes Administrator" (CKA) et "Microsoft Certified DevOps Engineer Expert".`,
    },
    {
      picture: 'images/team/kabore.jpeg',
      name: 'Windwaogo Christian Kabore',
      desc: `Windwaogo Christian est un professionnel  dans le domaine de la gouvernance, audit et sécurité des TI(GASTI). Il cumule aussi de nombreuses années d'expérience en Infrastructures technologiques, en sécurité applicative et la gestion des identités d'accès.
      Il a participé  à la transformation numérique  des grandes structures telles que SNC-LAVALIN ,Revenu Québec ,  Société  de l’assurance automobile du Québec(SAAQ) et  la Commission des normes, de l'équité, de la santé et de la sécurité du travail(CNESS)
      Il est titulaire d’une Maitrise en Informatique appliquée à la Gestion des Entreprises (MAIGE) à l’Institut burkinabè des Arts et Métiers (IBAM) et un DESS en gouvernance, audit et sécurité des TI à l’université de Sherbrooke`,
    },
  ],
};

export const emailFormKeys = {
  en: {
    sender: 'Name',
    email: 'Email',
    note: 'Tell us more about your needs...',
  },
  fr: {
    sender: 'Nom',
    email: 'Email',
    note: 'Parlez nous de quoi vous avez besoin...',
  },
};
